import { StateCreator } from 'zustand';
import { CedarStore } from './types';

// Interface for userInfo state
export interface UserInfo {
	id?: string;
	name?: string;
	email?: string;
	role?: string;
	userId?: string; // Added userId
}

// Interface for userMetadata state
export interface UserMetadata {
	preferences?: Record<string, unknown>;
	settings?: Record<string, unknown>;
	history?: Record<string, unknown>;
}

// Define the slice for user context
export interface UserContextSlice {
	userInfo: UserInfo;
	userMetadata: UserMetadata;
	userId?: string; // Keep separate for easier access if needed
	setUserInfo: (info: UserInfo) => void;
	updateUserInfo: (partialInfo: Partial<UserInfo>) => void;
	setUserMetadata: (metadata: UserMetadata) => void;
	updateUserMetadata: (partialMetadata: Partial<UserMetadata>) => void;
	setUserId: (userId: string) => void; // Action to set userId
}

// Create the slice
export const createUserContextSlice: StateCreator<
	CedarStore,
	[],
	[],
	UserContextSlice
> = (set) => ({
	// Default state
	userInfo: {},
	userMetadata: {},
	userId: undefined,

	// Actions
	setUserInfo: (info: UserInfo) => set({ userInfo: info }),
	updateUserInfo: (partialInfo: Partial<UserInfo>) =>
		set((state: CedarStore) => ({
			userInfo: { ...state.userInfo, ...partialInfo },
			// Also update top-level fields if they exist in partialInfo
			...(partialInfo.userId && { userId: partialInfo.userId }),
		})),

	setUserMetadata: (metadata: UserMetadata) => set({ userMetadata: metadata }),
	updateUserMetadata: (partialMetadata: Partial<UserMetadata>) =>
		set((state: CedarStore) => ({
			userMetadata: { ...state.userMetadata, ...partialMetadata },
		})),

	setUserId: (userId: string) => set({ userId }),
});
